import React, { useState } from 'react';
import { crearFractal } from '../api/fractalService';

const FractalCreationForm = ({ onFractalCreated }) => {
  const [nombre, setNombre] = useState('');

  const handleCreateFractal = () => {
    crearFractal({ nombre }).then((nuevoFractal) => {
      onFractalCreated((prev) => [...prev, nuevoFractal]);  // Actualiza la lista
      setNombre('');
    });
  };

  return (
    <div>
      <input
        type="text"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        placeholder="Nombre del fractal"
      />
      <button onClick={handleCreateFractal}>+</button>
    </div>
  );
};

export default FractalCreationForm;
